class ContactDetails {
    constructor(contactDetails) {
        this.firstName = contactDetails ? contactDetails.FirstName : "";
        this.lastName = contactDetails ? contactDetails.LastName : "";
        this.email = contactDetails ? contactDetails.Email : "";
    }
}
export default ContactDetails;
